import React, {useEffect, useState} from "react";
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import {handleFocusTextInput} from "../../helpers/handleFocusTextInput";
import i18n from "i18next";

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        marginBottom: 10,
        marginLeft: '10px',
        paddingRight: '10px',
    },
}));

const saveAnotherQuestion = (question, selectedCode, oldSelectedAnswers, text) => {
    let newSelectedAnswers = [];
    oldSelectedAnswers.forEach(oldSelectedAnswer => {
        newSelectedAnswers.push({
            questionCode: oldSelectedAnswer.questionCode,
            answerCode: oldSelectedAnswer.answerCode,
            isSelected: oldSelectedAnswer.isSelected,
            text: text
        });
    });
    return newSelectedAnswers;
};

const withAnotherQuestion = BaseComponent => (props) => {
    const {question, selectAnswer, markNextAble, studentAnswers} = props;
    const classes = useStyles();
    let idAnotherAnswer = `idAnotherAnswer${question.questionCode}`;
    let anotherAnswer = localStorage.getItem(idAnotherAnswer) ? localStorage.getItem(idAnotherAnswer) : '';
    const [keyword, setKeyWord] = useState(anotherAnswer);
    const [nextAnotherAble, setNextAnotherAble] = useState(false);

    useEffect(() => {
        if (keyword) {
            localStorage.setItem(idAnotherAnswer, keyword);
            setNextAnotherAble(true);
            markNextAble(true);
        } else {
            localStorage.removeItem(idAnotherAnswer);
            //setNextAnotherAble(false);
        }
        //markNextAble(nextAnotherAble);
    }, [keyword]);

    const handleChange = (event) => {
        if (event.target.value) {
            setNextAnotherAble(true);
        } else {
            setNextAnotherAble(false);
        }
        setKeyWord(event.target.value);
        selectAnswer(question.questionCode, saveAnotherQuestion(question, `${question.questionCode}_another`, studentAnswers, event.target.value));
    };

    const anotherQuestion =
        <TextField
            autoComplete="off"
            onFocus={handleFocusTextInput}
            className={classes.root}
            id={idAnotherAnswer}
            label={i18n.t('your_opinion')}
            value={keyword}
            onChange={handleChange}
            InputProps={{
                endAdornment: <ClearIcon onClick={() => {
                    setKeyWord('');
                    setNextAnotherAble(false);
                }}/>,
            }}
        />;

    return (
        <React.Fragment>
            <BaseComponent  {...props} anotherQuestion={anotherQuestion} anotherAnswer={anotherAnswer} keyword={keyword}
                            setKeyWord={setKeyWord} nextAnotherAble={nextAnotherAble}/>
        </React.Fragment>
    )
};

export default withAnotherQuestion;